module.exports = __webpack_public_path__ + "img/immigration.43a4193f.png";